module.exports = __webpack_public_path__ + "assets/normal/images/share1.fa0c7001.png";